module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo32.4b165979.jpg";